<script lang="ts">
  import '@splidejs/splide/dist/css/themes/splide-default.min.css';
  import { afterUpdate, onDestroy, onMount } from 'svelte';
  import { isMobileWidth } from '../../../common/util';
  import BasketLevelPromotion from '../../common/components/BasketLevelPromotion.svelte';
  import ExtraSnackBar from '../../common/components/ExtraSnackBar.svelte';
  import IntersectionObserver from '../../common/components/IntersectionObserver.svelte';
  import ProductTilePriceNewGroup from '../../common/components/productTile/components/ProductTilePriceNewGroup.svelte';
  import ExtraAmplienceBannerComponent from '../../common/lazy-components/ExtraAmplienceBannerComponent.svelte';
  import { getCMSComponentsFromHybrisAsync } from '../../common/services/hybris';
  import AddToCartContainer from '../../product-details/components/AddToCartContainer.svelte';
  import AddToCartDialog from '../../product-details/components/AddToCartDialog.svelte';
  import PdpBundlePromotion from '../../product-details/components/PdpBundlePromotion/PdpBundlePromotion.svelte';
  import PdpDealTimer from '../../product-details/components/PdpDealTimer.svelte';
  import ManualBundle from '../../product-details/components/PDPFrequentlyBought/ManualBundle.svelte';
  import PdpGiftOption from '../../product-details/components/PdpGiftOption.svelte';
  import PdpInstallmentsCard from '../../product-details/components/PDPInstallmentsCard.svelte';
  import PdpMoreInfoContent from '../../product-details/components/PdpMoreInfoContent.svelte';
  import PdpOffersCard from '../../product-details/components/PDPOffersCard.svelte';
  import PdpServicesCard from '../../product-details/components/PDPServicesCard.svelte';
  import PdpServicesCardv2 from '../../product-details/components/PDPServicesCardv2.svelte';
  import ProductDetailsSameSku from '../../product-details/components/ProductDetailsSameSKU/ProductDetailsSameSKU.svelte';
  import ProductExtraLinks from '../../product-details/components/ProductExtraLinks.svelte';
  import ProductImages from '../../product-details/components/productImages.svelte';
  import ProductSpecialOffers from '../../product-details/components/ProductSpecialOffers.svelte';
  import ProductTitle from '../../product-details/components/ProductTitle.svelte';
  import ProductUnAvailable from '../../product-details/components/ProductUnAvailable.svelte';
  import StickyBar from '../../product-details/components/StickyBar.svelte';
  import {
    addGiftToCartPayload,
    addProductToCart,
    manualBundlePayload,
    onClickWishlist,
    sendBundleCartData,
  } from '../../product-details/services/pdp-data-services';
  import {
    addToCartData,
    pdpBundlePromotionData,
    pdpGiftCardPriceData,
    pdpManualBundleData,
    pdpProductExtraLinksData,
    pdpProductPrice,
    pdpSpecsAndStickyBarData,
    pdpTitleData,
    productDetailMainData,
    productDetails,
    productImagesData,
    prodUnavailableData,
    selectedGiftGroup,
    selectedGifts,
    testFreakData,
  } from '../../product-details/store/pdp_store';
  import {
    addToCartContent,
    currentSelectedStoreData,
    openAddToCartDrawer,
    pdpInstalmentCardData,
    pdpOfferCardData,
    pdpServiceCardData,
  } from '../../product-details/store/pdp_store.js';
  import { getPreorderProductDetails, getTabDetails } from '../services/preorder-data-services';
  import DeliveryDetails from './DeliveryDetails.svelte';
  import Highlights from './Highlights.svelte';
  import PreorderModels from './PreorderModels.svelte';

  export let metaData;
  export let selectedTab;
  export let bannerDetails;

  let addToCartButton: HTMLDivElement;
  let loaded = false;
  let hideTopAddToCart = true;
  let selectedModel: any = null;
  let bannerInitialized = false;
  let promotionBannerInitialized = false;
  let activeModel: any = null;
  let navHeight = 0;
  let headerHeight = 0;
  let tabsData = [];
  let productDetailsData: any = {};
  let defaultProductId: any = null;
  let highlightsArray: any = [];
  let modelsArray: any = [];
  let bannerComp;
  let promotionBannerComp;
  const isResponsive = isMobileWidth();
  let isProductOOS = false;
  let preorderTimerFlag = false;
  let timeoutId;

  $: hasBundlePromotions =
    $productDetailMainData?.specialOfferDataList && $productDetailMainData?.specialOfferDataList.length > 0;
  $: {
    const { cfsBackOrderEligible, cfsBackOrderLaunchDate, homeDeliveryData, isCollectFromStoreEnabled } =
      $addToCartData;

    // Check if backorder is eligible and launch date is available and isCollectFromStoreEnabled is true
    if (cfsBackOrderEligible && cfsBackOrderLaunchDate && isCollectFromStoreEnabled) {
      // enable button
      isProductOOS = false;
    }
    // If home delivery is out of stock, disable the button
    else if (homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'outOfStock') {
      isProductOOS = true;
    }
    // Default case: button enabled
    else {
      isProductOOS = false;
    }
  }

  $: showPriceForComingSoon =
    !$productDetailMainData?.isComingSoon ||
    ($productDetailMainData?.isComingSoon && !$productDetailMainData?.hidePriceForComingSoon);

  $: if (bannerComp && !bannerInitialized) {
    bannerInitialized = true;
    bannerComp.onLoad();
  }

  $: if (promotionBannerComp && !promotionBannerInitialized) {
    promotionBannerInitialized = true;
    promotionBannerComp.onLoad();
  }

  function getModelProductDetails(modelTabsHighlightsIds, productId = null, isLoad = false) {
    try {
      return getCMSComponentsFromHybrisAsync(modelTabsHighlightsIds.split(' '))
        .then((res: any) => res.component)
        .then(compArray => {
          const mappedData = compArray.map(v => ({
            ...v,
          }));
          const highlightComponents = mappedData?.filter(item => item.typeCode === 'ExtraPreOrderHighlightComponent');
          const modelComponents = mappedData?.filter(item => item.typeCode !== 'ExtraPreOrderHighlightComponent');
          if (productId) {
            tabsData = [{ highlightComponents }, { modelComponents: [{ product: productId }] }];
          } else {
            if (isLoad) {
              activeModel = modelComponents?.[0]?.uid;
            }
            tabsData = [{ highlightComponents }, { modelComponents }];
          }
          return tabsData;
        })
        .then(ld => (loaded = ld.length > 0));
    } catch (err) {
      console.error(err);
    }
  }

  async function loadProductDetails(productId = null) {
    if (!productId) {
      return false;
    }
    try {
      const selectedTabDetails = getTabDetails(metaData, selectedTab);
      const dealEndDate = selectedTabDetails?.[0]?.preOrderEndDate || null;
      const dealStartDate = selectedTabDetails?.[0]?.preOrderStartDate || null;

      selectedModel = productId;
      productDetailsData = await getPreorderProductDetails(productId);

      productDetailsData.endDateDeal = dealEndDate;
      productDetailsData.comingSoonTimerDate = dealStartDate;
      productDetails.set(productDetailsData);
      $productDetails = productDetailsData;
      window['ACC'].config.productDetails = $productDetails;

      currentSelectedStoreData.set({
        stockLevelStatus: {
          code: $productDetailMainData.cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevelStatus?.code,
          type: $productDetailMainData.cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevelStatus?.type,
        },
        stockLevel: $productDetailMainData.cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevel,
        stockThreshold: $productDetailMainData.cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockThreshold,
      });
    } catch (err) {
      window['ACC'].loader.hideLoader();
      console.error(err);
    } finally {
      window['ACC'].loader.hideLoader();
    }
  }
  let isWhishList = $productDetails?.inWhishList === true ? true : false;
  //const wishlisted = isWhishList;
  $: wishlistedItemId = $productDetails?.wishlistEntryPk;

  function handleWishlistChange(data) {
    onClickWishlist(data, isWhishList, wishlistedItemId);
  }

  function onAddToCart(): void {
    addProductToCart(
      $productDetailMainData?.isTransactional,
      $productDetailMainData?.hasFreeGift,
      $productDetailMainData?.freeGiftDataList,
      $selectedGifts,
      $selectedGiftGroup,
      $productDetailMainData?.isRSAItem
    );
  }

  async function loadComponent(isLoad = false) {
    const selectedTabDetails = getTabDetails(metaData, selectedTab);
    if (!selectedTabDetails) {
      return false;
    }
    const modelTabs = selectedTabDetails?.[0]?.modelTabs || '';
    const highlights = selectedTabDetails?.[0]?.highlights || '';
    if (!modelTabs) {
      if (selectedTabDetails?.[0]?.defaultProduct) {
        defaultProductId = selectedTabDetails?.[0]?.defaultProduct;
      }
    }
    getModelProductDetails(`${modelTabs} ${highlights}`, defaultProductId, isLoad);
  }

  function handleModelClick(modelDetails, variantClick = false) {
    const productId = modelDetails?.detail?.product || modelDetails;
    const currentModelTab = modelDetails?.detail?.uid;
    if ((variantClick && selectedModel === productId) || (!variantClick && activeModel === currentModelTab)) {
      return false;
    }
    window['ACC'].loader.showLoader();
    loadProductDetails(productId);

    if (!variantClick) {
      activeModel = currentModelTab;
    }
  }

  $: if (tabsData && tabsData?.length && tabsData?.some(item => item?.modelComponents)) {
    const preorderProductId = tabsData?.find(item => item?.modelComponents)?.modelComponents?.[0]?.product;
    if (preorderProductId) {
      highlightsArray = tabsData?.find(item => item?.highlightComponents)?.highlightComponents;
      modelsArray = tabsData?.find(item => item?.modelComponents)?.modelComponents;
      loadProductDetails(preorderProductId);
    }
  }

  $: if (
    ($productDetailMainData?.isComingSoon && $productDetailMainData?.comingSoonTimerDate) ||
    $productDetailMainData?.endDateDeal
  ) {
    timeoutId = setTimeout(() => {
      preorderTimerFlag = true;
    }, 2000);
  }

  function scrollContainer() {
    return document.documentElement || document.body;
  }

  function handleOnScroll() {
    if (!scrollContainer()) {
      return;
    }
    let buttonTop = 0;
    if (addToCartButton) {
      const rect = addToCartButton?.getBoundingClientRect();
      buttonTop = rect?.top;
    }

    if (buttonTop >= -12) {
      hideTopAddToCart = true;
      document.querySelector('html').classList.remove('pdp-sticky-added');
    } else {
      hideTopAddToCart = false;
      document.querySelector('html').classList.add('pdp-sticky-added');
    }
  }

  function addBundleToCart(index) {
    sendBundleCartData(index);
  }

  function stickyHeader() {
    navHeight = document.querySelector('.header-desktop')?.clientHeight;
    navHeight = navHeight ? navHeight : 80;
    headerHeight = document.querySelector('.left-content')?.clientHeight;
    headerHeight = headerHeight ? headerHeight : 1470;
    document.documentElement.style.setProperty('--stickyBarTop', `${navHeight}px`);
  }

  afterUpdate(() => {
    stickyHeader();
  });

  onMount(async () => {
    stickyHeader();
    loadComponent(true);
  });

  onDestroy(() => {
    clearTimeout(timeoutId);
  });
</script>

<svelte:window on:scroll={handleOnScroll} />
{#if loaded && productDetailsData && Object.keys(productDetailsData).length > 0}
  {#if $productDetailMainData?.isDigitalGiftCard || (!$productDetailMainData?.isComingSoon && $productDetailMainData?.stock.stockLevelStatus.code != 'outOfStock')}
    {#if !hideTopAddToCart}
      <div class="sticky_header_bar hide-on-mobile">
        <StickyBar
          preorder={true}
          data={$pdpSpecsAndStickyBarData}
          on:addToCart={() => onAddToCart()}
          on:changeWishList={data => {
            handleWishlistChange(data);
          }}
        />
      </div>
    {/if}
  {/if}
  {#if bannerDetails?.[0]?.banner}
    <div class="c_preorderbanner">
      <ExtraAmplienceBannerComponent preorder={true} metaData={bannerDetails[0].banner} bind:this={bannerComp} />
    </div>
  {/if}
  <div class:hide={!preorderTimerFlag}>
    <PdpDealTimer preorder={true} />
  </div>
  <div class="c_productdetailcontainer">
    {#if isResponsive}
      <ProductTitle data={$pdpTitleData} preorder={true} />
    {/if}

    <div class="left-content">
      <div class="light-container">
        <ProductImages data={$productImagesData} ProductRatingData={$testFreakData} preorder={true} />
      </div>
    </div>

    <div class="right-content c_productright">
      <div class="right-bg position-relative">
        <div id="zoomed-img-container"></div>
        {#if highlightsArray?.length && !$productDetailMainData?.isComingSoon}
          <Highlights highlights={highlightsArray} />
        {/if}
        <div class="d-flex flex-column content-padding">
          {#if !isResponsive}
            <ProductTitle data={$pdpTitleData} preorder={true} />
          {/if}

          {#if !$productDetailMainData?.isComingSoon && !isProductOOS}
            <DeliveryDetails data={$productDetails} />
          {/if}

          {#if !defaultProductId && modelsArray?.length}
            <PreorderModels
              models={modelsArray}
              {activeModel}
              on:modelClick={event => handleModelClick(event)}
              {showPriceForComingSoon}
            />
          {/if}

          {#if $productDetailMainData.productVariantGroups && $productDetailMainData.productVariantGroups.length > 0}
            <ProductDetailsSameSku
              productVariantGroups={$productDetailMainData.productVariantGroups}
              code={$productDetailMainData.code}
              preorder={true}
              on:modelClick={event => handleModelClick(event?.detail, true)}
              productData={$productDetailMainData}
            />
          {/if}

          {#if !$productDetailMainData?.isComingSoon && Array.isArray($productDetailMainData?.freeGiftDataList) && $productDetailMainData.freeGiftDataList.length > 0}
            <div class="c_preorder-gifts">
              <PdpGiftOption
                preOrder={true}
                isModel={false}
                freeGiftDataList={$productDetailMainData?.freeGiftDataList}
                on:giftSelectionForCart={addGiftToCartPayload}
              />
            </div>
          {/if}
        </div>
      </div>
      {#if !$productDetailMainData?.isComingSoon}
        <div class="c_preorder-services">
          <PdpServicesCardv2 data={$pdpServiceCardData} eligibleVasEntries={$pdpServiceCardData.eligibleVasEntries} />
          <PdpServicesCard serviceType="appleCare" />
        </div>
      {/if}

      {#if showPriceForComingSoon}
        <PdpInstallmentsCard data={$pdpInstalmentCardData} />
      {/if}

      {#if !$productDetailMainData?.isComingSoon}
        <div class="c_preorderoffersection">
          <PdpOffersCard
            data={$pdpOfferCardData}
            preorder={Array.isArray($productDetailMainData?.freeGiftDataList) &&
            $productDetailMainData.freeGiftDataList.length > 0
              ? true
              : false}
          />
        </div>
      {/if}

      <div class="d-flex flex-column c_preorderprice-container desktop-price">
        {#if !isResponsive && showPriceForComingSoon && $productDetailMainData?.isAddToCartEnabled}
          <div class="d-flex justify-content-center">
            <ProductTilePriceNewGroup
              isMegasaleProduct={$productDetailMainData?.isMegaSaleThemedProduct}
              product={$pdpProductPrice}
              pdpGiftCardPriceData={$pdpGiftCardPriceData}
              variant="pdp"
            />
          </div>
        {/if}

        {#if ($productDetailMainData?.isComingSoon && $productDetailMainData?.isDigitalGiftCard != true) || ($productDetailMainData?.stock.stockLevelStatus.code == 'outOfStock' && $productDetailMainData?.isDigitalGiftCard != true)}
          <ProductUnAvailable
            data={$prodUnavailableData}
            on:changeWishList={data => {
              handleWishlistChange(data);
            }}
          />
        {:else if $productDetailMainData?.isAddToCartEnabled}
          <div class="hide-on-mobile" bind:this={addToCartButton}>
            <AddToCartContainer
              data={$addToCartData}
              on:addToCart={() => onAddToCart()}
              on:changeWishList={data => {
                handleWishlistChange(data);
              }}
            />
          </div>
        {/if}
        {#if !isResponsive}
          <div class="c_preorder-externallink">
            <ProductExtraLinks data={$pdpProductExtraLinksData} />
          </div>
        {/if}
      </div>
    </div>
  </div>

  <section class="add-to-cart-dialog-wrapper">
    <AddToCartDialog content={$addToCartContent} open={$openAddToCartDrawer} />
  </section>

  {#if bannerDetails?.[0]?.promotionBanner}
    <div class="c_preorderpromotionbanner">
      <ExtraAmplienceBannerComponent
        preorder={true}
        metaData={bannerDetails[0].promotionBanner}
        bind:this={promotionBannerComp}
      />
    </div>
  {/if}

  {#if !$productDetailMainData?.isComingSoon && ($productDetails?.potentialPromotions?.length || $productDetailMainData?.basketPromotions)}
    <div class="c_preorder-offers bottom-content-special-offers">
      <BasketLevelPromotion basketPromotions={$productDetailMainData?.basketPromotions} />
      <ProductSpecialOffers />
    </div>
  {/if}

  <PdpMoreInfoContent data={$pdpSpecsAndStickyBarData} isDataLoaded={true} preorder={true} />

  {#if $productDetailMainData?.stock?.stockLevelStatus?.code != 'outOfStock' && !$productDetailMainData?.isComingSoon && hasBundlePromotions}
    <PdpBundlePromotion data={$pdpBundlePromotionData} on:bundleClicked={data => addBundleToCart(data.detail)} />
  {/if}

  <IntersectionObserver>
    {#if $productDetailMainData?.stock?.stockLevelStatus?.code != 'outOfStock' && !$productDetailMainData?.isComingSoon && $productDetailMainData?.manualBundleProducts?.length > 0}
      <div class="c_preorder-bundle">
        <ManualBundle
          preorder={true}
          manualBundleData={$pdpManualBundleData}
          on:manualBundleToCart={manualBundlePayload}
        />
      </div>
    {/if}
  </IntersectionObserver>

  {#if isResponsive && showPriceForComingSoon && $productDetailMainData?.isAddToCartEnabled}
    <div class="hide-on-desktop sticky_scroll_bar add_to_cart-conatiner c_preorder-stickybtn">
      <div class="d-flex justify-content-center">
        <ProductTilePriceNewGroup
          isMegasaleProduct={$productDetailMainData?.isMegaSaleThemedProduct}
          product={$pdpProductPrice}
          pdpGiftCardPriceData={$pdpGiftCardPriceData}
          variant="pdp"
        />
      </div>
      {#if !$productDetailMainData?.isComingSoon && $productDetailMainData?.stock.stockLevelStatus.code !== 'outOfStock'}
        <AddToCartContainer
          data={$addToCartData}
          on:addToCart={() => onAddToCart()}
          on:changeWishList={data => handleWishlistChange(data)}
        />
      {/if}

      {#if $pdpProductExtraLinksData?.productIconLabelContents && $productDetailMainData?.stock.stockLevelStatus.code != 'outOfStock'}
        <div class="c_preorder-externallink">
          <ProductExtraLinks data={$pdpProductExtraLinksData} />
        </div>
      {/if}
    </div>
  {/if}
{/if}

<ExtraSnackBar />

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .bottom-content-special-offers {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .add_to_cart-conatiner {
    background: $primary-white;
    z-index: 3;
  }
  .sticky_scroll_bar {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .sticky_header_bar {
    position: fixed;
    top: 0px;
    width: 100%;
    left: 0;
    z-index: 14;
    filter: drop-shadow(0px 4px 12px rgba(219, 227, 232, 0.6));
  }
  :global {
    .pdp-details-story-dialog .offers-row,
    .pdp-details-story-dialog .finance-options-row {
      display: none;
    }
    html.pdp-sticky-added {
      .c_global-header.minimal {
        z-index: 10;
        .c_nav-main-bar {
          box-shadow: none;
        }
      }
      .sticky_header_bar .product_price {
        padding-top: 0;
      }
    }
    .c_preorder {
      .add_to_cart-conatiner.c_preorder-stickybtn {
        box-shadow: 0px -8px 12px rgba(219, 227, 232, 0.32);
        padding: 14px 0 10px;

        .product-price-new-container.variant-pdp.user-NOPRIME .middle .middle-left .price {
          font-size: 24px;
          line-height: 32px;
          .vat {
            font-size: 12px;
          }
        }
        .c_preorder-externallink {
          margin-top: 0;
        }
        .parent-div {
          box-shadow: none;
          margin-top: 0;
          .extra-btn .btn-lg {
            min-height: 44px;
            font-size: 16px;
          }
          .padd_desk {
            padding: 12px 16px 6px;
          }
        }
      }
      .c_productdetailcontainer {
        .tag-container {
          flex-direction: row;
        }
        .tags-container {
          top: 40px;
        }
      }
    }

    .PDPdealTimer {
      margin-top: 3px;
    }
  }
  .hide-on-mobile {
    @media screen and (max-width: 599px) {
      display: none;
    }
  }
</style>
